import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MICROSERVICES } from '@shared/constants/microservices';
import { ToastService, ToastType } from 'cve-ui';
import { ImpersonationFacade } from 'nextmove-common-impersonation';
import { catchError, throwError } from 'rxjs';
import { ALLOWED_REQUEST_URL } from '../../domain/constants/allowed-request-url.const';
import { B2cAuthenticationUseCaseService } from '../../features/authentication/aplication/b2c-authentication-use-case.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const impersonation = inject(ImpersonationFacade);
    const session = impersonation.session();

    const authToken = session?.accessToken || localStorage.getItem('token') || '';
    const tokenType = session?.tokenType || 'Bearer';
    const b2cService = inject(B2cAuthenticationUseCaseService);
    const toastService = inject(ToastService);
    const injector = inject(Injector);
    let headers = req.headers;

    if (checkUrlAllowed(req) && authToken) {
        headers = headers.set('Authorization', `${tokenType} ${authToken}`);
    }
    if (req.url.includes(MICROSERVICES.b2c)) {
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.B2C_FLEETS_HEADER);
    } else {
        headers = headers.append('Ocp-Apim-Subscription-Key', environment.FLEETS_HEADER);
    }
    if (headers !== req.headers) {
        req = req.clone({ headers });
    }

    return next(req).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                const translate = injector.get(TranslateService);

                toastService.show({
                    type: ToastType.error,
                    title: translate.instant('shared.toast.session_expired.title'),
                    label: translate.instant('shared.toast.session_expired.label'),
                });

                if (impersonation.isActive()) {
                    impersonation.clearSession();
                } else {
                    b2cService.logout();
                }
            }
            return throwError(() => error);
        })
    );
}

function checkUrlAllowed(request: HttpRequest<unknown>) {
    return ALLOWED_REQUEST_URL.some((url) => request.url.includes(url));
}
